import { IAssessmentState } from "@/store/modules/assessment/types";

export const state: IAssessmentState = {
  sections: [],
  section: null,
  answeredQuestions: null,
};
